export const formatDegrees = new Intl.NumberFormat('en-us', {
  style: 'unit',
  unit: 'degree',
  unitDisplay: 'narrow',
}).format
